import React, { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { LangContext } from "../../constantsLanguage/constLang";
import { TogleLang } from "./TogleLang";

import { Button } from "antd";

import useWindowSize from "../../../../../utils/hooks/useWindowSize";
import { Typograhy } from "../../../../components/ui/Typograhy/Typograhy";
import styles from "../shared/Shared.module.scss";
import { MobilHeader } from "./MobilHeader";
import { options } from "less";
export const HeaderNew = ({ data }) => {
  const history = useNavigate();
  const authToken = localStorage.getItem("token");
  const size = useWindowSize();
  const lang = LangContext();
  const questRecommendations = useMemo(() => {
    return data?.quest_recommendations;
  }, [data]);
  const questSkills = useMemo(() => {
    return data?.quest_skills;
  }, [data]);
  const Speakers = useMemo(() => {
    return data?.quest_speakers;
  }, [data]);
  const FormStydent = useMemo(() => {
    if (data) {
      const arrformat = Object.values(data?.progress);
      const res = arrformat.pop();
      return Object.values(arrformat).some((val) => val !== 0);
    }
  }, [data]);
  const isCourseContent = useMemo(() => {
    return data?.academicHours;
  }, [data]);

  const params = useParams();
  console.log("banerParams", params.id);

  return (
    <>
      {size.width > 1020 ? (
        <>
          <div className={styles.wrapperHeader}>
            <div className={styles.wrapperHeaderT}>
              <Typograhy label="Курсы" />
            </div>
            {Speakers?.length > 0 && <a href="#section1">{lang.variable_2}</a>}
            {FormStydent && <a href="#section2">{lang.variable_7}</a>}
            {isCourseContent && <a href="#section3">{lang.variable_53}</a>}
            {questRecommendations?.length > 0 && (
              <a href="#section4">{lang.variable_18}</a>
            )}
            {questSkills?.length > 0 && (
              <a href="#section6">{lang.variable_19}</a>
            )}
            <div>
              {!authToken && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "15px",
                  }}
                >
                  <TogleLang />
                  <div>
                    <Button
                      onClick={() =>
                        history("/student/auth", { state: params.id })
                      }
                    >
                      {lang.variable_6}
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          <MobilHeader speakers={Speakers} lang={lang} />

          {!authToken && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "15px",
              }}
            >
              <TogleLang />
              <div>
                <Button
                  onClick={() => history("/student/auth", { state: params.id })}
                >
                  {lang.variable_6}
                </Button>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};
